/**
 * @description Extracts the branch from the URL
 * @returns The branch from the URL, if it exists in format: BUY-**, TB-**, or BB-** (any amount of digits)
 */
const extractBranchFromUrl = (): string | undefined => {
    const branchMatch = window.location.href.match(/\/(BUY|TB|BB|TBPD)-\d+/g);
    return branchMatch?.[0].replaceAll('/', '');
};

export { extractBranchFromUrl };
